import { externalShipmentAffValidate } from '../../application/dtos/external_shipment_aff_validate';

export class ExternalShipmentAffEntity {
    constructor({id, unique_order_number, shipment_number, shipping_service, total, created_at, client, invoice}){
        this.id = id;
        this.unique_order_number = unique_order_number;
        this.shipment_number = shipment_number;
        this.shipping_service = shipping_service;
        this.total = total;
        this.created_at = created_at;
        this.client = client;
        this.invoice = invoice;
    }

    isValid() {
        // return this.name && this.price >= 0;
        return externalShipmentAffValidate(this);
    }
}